module.exports = __webpack_public_path__ + "img/m.2eb50ee1.jpg";